import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
  }
  start: string
  end: string
}

export default function useGetHeatmapData({enabled, filter, start, end}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_PERSONALIZED_COUNTING_WITH_AVERAGE, filter, enabled, start, end],
    queryFn: async () => (await api.reports.getHeatmapFaces({filter, start, end})).data.data,
  })

  return query
}
